import { useEffect, useState } from 'react'

import { useApi } from '@/hooks'

export interface Customer {
  id: number
  name: string
}

/** Customers the caller can see (GET /customers — Postgres customer table). */
export const useCustomers = () => {
  const { api } = useApi()
  const [customers, setCustomers] = useState<Customer[]>([])
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    let cancelled = false
    setIsLoading(true)
    api
      .get<Customer[]>({ path: '/customers', origin: 'TrackerMap' })
      .then((r) => {
        if (!cancelled && !r.error) setCustomers(r.data ?? [])
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false)
      })
    return () => {
      cancelled = true
    }
  }, [api])

  return { customers, isLoading }
}
